import * as constant from "./constant";
import { constant as layoutConstant } from "store/Layout";
import { Get } from "utils/request";
import { API } from "utils/api";
import { fromJS } from "immutable";
import { Post } from "utils/request";
import { message } from "antd";
import { sum } from "utils/arr";
import {
  getGroup,
  groupIdOf,
  getOtherTables,
  isTableFilled,
  isCurrentRoundDraft,
  markPrompted,
  getPending,
  setPending,
  buildValueMap,
  applyValueMap
} from "utils/copyScore";
import { applySuggestAsValue, isTableEmpty } from "utils/suggest";

export const changeItem = (target, value) => ({
  type: constant.CHANGE_ITEM,
  target: target,
  value: value
});

export const changeScoreCard = (source) => ({
  type: constant.CHANGE_SCORE_CARD,
  source
});

export const currentUserIsScored = () => {
  return (dispatch) => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      Get(`${API.SCORER}/${userId}`).then((res) => {
        // 校验通过
        dispatch({
          type: constant.CHANGE_ITEM,
          target: ["modal", "isLogin"],
          value: true
        });
        dispatch({
          type: constant.CHANGE_ITEM,
          target: ["userInfo"],
          value: fromJS(res)
        });
      });
    }
  };
};

export const submitUserInfo = (values, signature) => {
  return (dispatch) => {
    let data = values;
    data.signature = signature;

    Post(API.SCORER, data).then((res) => {
      dispatch({
        type: constant.CHANGE_ITEM,
        target: ["userInfo"],
        value: fromJS(res)
      });

      localStorage.setItem("userId", res.id);
      dispatch({
        type: constant.CHANGE_ITEM,
        target: ["currentPage"],
        value: 1
      });
    });
  };
};

export const loadProject = (projectId) => {
  return (dispatch, getState) => {
    Get(
      `${API.PROJECT_BASE}/${projectId}?t=1&u=${localStorage.getItem("userId")}`
    ).then((res) => {
      dispatch({
        type: constant.CHANGE_ITEM,
        target: ["projectInfo"],
        value: fromJS(res)
      });

      // TaskPage（currentPage=1）就是评分页：项目信息加载完成后，
      // 直接并行加载项目下所有评分表，以 Tabs + 表格形式展示。
      // SignPage（currentPage=0）仅加载项目信息，不触发全表加载。
      if (getState().getIn(["score", "currentPage"]) === 1) {
        dispatch(loadAllTables(fromJS(res)));
      }
    });
  };
};

export const loadScoreTable = (tableId, projectInfo) => {
  return (dispatch) => {
    dispatch({
      type: layoutConstant.CHANGE_ITEM,
      target: ["pageLoading"],
      value: true
    });

    Get(
      `${API.TABLE_BASE}/${tableId}?rounds=${projectInfo.get(
        "status"
      )}&u=${localStorage.getItem("userId")}`
    ).then((res) => {
      res = fromJS(res);

      // 关联评分表回填：若该表属于某分组、存在待复制数据、非源表、且该表尚未评分，
      // 则用源表数据回填显示（默认视图就是 A 复制过来的数据）。
      // 注意：
      // 1) 不能用 pending.appliedTables 判定——刷新后 appliedTables 已含本表，
      //    会导致不再回填。
      // 2) 回填只影响页面显示（currentTableInfo），打开表时不再调用 autoSave，
      //    因此不会把回填数据写进 localStorage 覆盖用户修改后的自动保存内容；
      //    用户修改后的数据由"是否加载自动保存内容"弹窗点确定恢复。
      const projectId = String(projectInfo.get("id"));
      const tid = String(tableId);
      const group = getGroup(projectId, tid);
      if (group) {
        const groupId = groupIdOf(group);
        const pending = getPending(projectId, groupId);
        if (pending && pending.sourceTableId !== tid) {
          const tables = projectInfo.get("tables");
          const tableItem =
            tables && tables.find((i) => String(i.get("id")) === tid);
          const isScored = !!(tableItem && tableItem.get("status"));
          if (!isScored) {
            res = applyValueMap(res, pending.valueMap);
          }
        }
      }

      dispatch({
        type: constant.CHANGE_ITEM,
        target: ["currentTableInfo"],
        value: res
      });

      // 打开新表时强制关闭"导航卡"侧边抽屉：
      // modal.scoreDrawer 一旦打开过就不会自动复位（返回列表/提交均不清除），
      // 不重置会导致下次打开评分表时抽屉残留弹出。
      dispatch({
        type: constant.CHANGE_ITEM,
        target: ["modal", "scoreDrawer"],
        value: false
      });

      dispatch({
        type: constant.CHANGE_ITEM,
        target: ["scoreCard"],
        value: fromJS({
          data: res.get("basic"),
          type: "basic"
        })
      });

      dispatch({
        type: constant.CHANGE_ITEM,
        target: ["currentPage"],
        value: 2
      });

      // 打开表时【不】调用 autoSave：
      // - 刚进入评分表（含回填 A 数据）不应触发"自动保存成功"，也不应把加载的数据
      //   写入 localStorage——否则会覆盖用户之前修改后保存的自动保存内容，
      //   导致"是否加载自动保存内容"点确定恢复不出修改后的数据。
      // - 自动保存只在用户实际操作时触发（切换层级 changeScoreCard 等）。
      dispatch({
        type: layoutConstant.CHANGE_ITEM,
        target: ["pageLoading"],
        value: false
      });
    });
  };
};

export const inputValueChange = (target, value) => ({
  type: constant.CHANGE_FACTOR_VALUE,
  target,
  value
});

/**
 * 项目级多表加载：并行 GET 项目下所有评分表，写入 tablesMap，
 * 激活第一张未评分表（全部已评分则激活第一张）。
 * 兼容单表加载的 copyScore 回填逻辑。
 */
export const loadAllTables = (projectInfo) => {
  return (dispatch) => {
    dispatch({
      type: layoutConstant.CHANGE_ITEM,
      target: ["pageLoading"],
      value: true
    });

    const tables = projectInfo.get("tables");
    const tids = tables.map((t) => String(t.get("id"))).toArray();
    const rounds = projectInfo.get("status");
    const userId = localStorage.getItem("userId");

    if (!tids.length) {
      dispatch({
        type: layoutConstant.CHANGE_ITEM,
        target: ["pageLoading"],
        value: false
      });
      return;
    }

    Promise.all(
      tids.map((tid) =>
        Get(`${API.TABLE_BASE}/${tid}?rounds=${rounds}&u=${userId}`)
      )
    )
      .then((resArr) => {
        const projectId = String(projectInfo.get("id"));
        const tablesMap = {};
        resArr.forEach((res, i) => {
          let table = fromJS(res);
          const tid = tids[i];

          // 第 2 轮起的历史分数回填由后端完成（GET /table/{id}?rounds=N 返回
          // 该专家本轮已提交/上一轮数据），前端不再从 localStorage 回填显示；
          // localStorage 缓存只用于"是否加载自动保存内容"弹窗的轮次判断
          // （见 CHECK_AUTO_SAVE / isCurrentRoundDraft）。

          const tableItem = tables.find((t) => String(t.get("id")) === tid);
          const isScored = !!(tableItem && tableItem.get("status"));

          // copyScore 回填（pending，当前轮复制的数据，覆盖后端回填的历史分数）
          const group = getGroup(projectId, tid);
          if (group && !isScored) {
            const pending = getPending(projectId, groupIdOf(group));
            if (pending && pending.sourceTableId !== tid) {
              table = applyValueMap(table, pending.valueMap);
            }
          }

          // 建议分值预填「权重打分」：仅第 1 轮生效。
          // 第 2 轮起后端会回填该专家第 1 轮的已提交数据（GET /table/{id}?rounds=N
          // 返回值），因此第 2 轮不再用建议值预填，直接沿用后端回填结果；
          // 若第 1 轮未提交、无缓存可回填，则第 2 轮表为空、也不预填，由专家从零填写。
          // 第 1 轮预填条件：
          //   - 本轮已提交（isScored）→ 保留后端返回的已提交分数
          //   - 有当前轮缓存（isCurrentRoundDraft）→ 交给"是否加载自动保存内容"弹窗
          //   - 表内已有值 → 不覆盖
          // 注意此处只改内存展示值，不写 localStorage：预填不算"用户填写过"，
          // 不影响 copyScore 的"三张表都未填写才提示复制"判断。
          if (
            rounds === 1 &&
            !isScored &&
            !isCurrentRoundDraft(tid, rounds) &&
            isTableEmpty(table)
          ) {
            table = applySuggestAsValue(table, rounds);
          }

          tablesMap[tid] = table;
        });

        // 激活第一张未评分表
        let activeTid = null;
        tables.forEach((t) => {
          if (!activeTid && !t.get("status")) {
            activeTid = String(t.get("id"));
          }
        });
        if (!activeTid) activeTid = tids[0];

        dispatch({
          type: constant.LOAD_ALL_TABLES,
          tablesMap,
          activeTableId: activeTid
        });

        // 关闭导航卡抽屉 + 检测本地自动保存（保持 currentPage=1，TaskPage 即评分页）
        dispatch({
          type: constant.CHANGE_ITEM,
          target: ["modal", "scoreDrawer"],
          value: false
        });
        dispatch({
          type: constant.CHECK_AUTO_SAVE,
          tableId: activeTid
        });
        dispatch({
          type: layoutConstant.CHANGE_ITEM,
          target: ["pageLoading"],
          value: false
        });
      })
      .catch(() => {
        message.error("评分表加载失败，请稍后重试");
        dispatch({
          type: layoutConstant.CHANGE_ITEM,
          target: ["pageLoading"],
          value: false
        });
      });
  };
};

/**
 * 切换激活表（tab 切换）：旧表编辑态已实时写入 tablesMap，
 * 此处直接切 activeTableId + currentTableInfo + scoreCard，并检测本地自动保存。
 */
/**
 * 切换激活表（tab 切换）：旧表编辑态已实时写入 tablesMap，
 * 此处直接切 activeTableId + currentTableInfo + scoreCard，并检测本地自动保存。
 * 弹窗规则：每个表"首次"遇到有自动保存内容时询问一次；
 * 已选择过（恢复或忽略）的表切回来不再弹（见 reducer CHECK_AUTO_SAVE / autoSaveHandled）。
 */
export const switchTable = (tableId) => {
  return (dispatch) => {
    const tid = String(tableId);
    dispatch({
      type: constant.SWITCH_TABLE,
      tableId: tid
    });
    dispatch({
      type: constant.CHECK_AUTO_SAVE,
      tableId: tid
    });
  };
};

/**
 * 表格单元格输入：直接更新 tablesMap[tableId][level] 中因子的 value，
 * 并触发 autoSave。level ∈ {basic, normal, sub}
 */
export const tableValueChange = (tableId, level, factorId, value) => {
  return (dispatch) => {
    dispatch({
      type: constant.TABLE_VALUE_CHANGE,
      tableId: String(tableId),
      level,
      factorId,
      value
    });
    dispatch(autoSave());
  };
};

/**
 * 校验当前评分表分数是否通过（基本层=100；派生层/因子层合计%100===0）
 */
export const validateScore = (currentTableInfo) => {
  const basicValues = currentTableInfo
    .get("basic")
    .filter((i) => i.get("status", 1) !== 0)
    .map((i) => i.get("value", -1))
    .toArray();
  if (basicValues.indexOf(-1) !== -1 || parseInt(sum(basicValues)) !== 100) {
    return false;
  }

  const normalValues = currentTableInfo
    .get("normal")
    .filter((i) => i.get("status", 1) !== 0)
    .map((i) => i.get("value", -1))
    .toArray();
  if (
    normalValues.indexOf(-1) !== -1 ||
    parseInt(sum(normalValues)) % 100 !== 0
  ) {
    return false;
  }

  const subValues = currentTableInfo
    .get("sub")
    .filter((i) => i.get("status", 1) !== 0)
    .map((i) => i.get("value", -1))
    .toArray();
  if (subValues.indexOf(-1) !== -1 || parseInt(sum(subValues)) % 100 !== 0) {
    return false;
  }

  return true;
};

/**
 * "确定/提交"按钮点击：先校验，再判断是否需要弹出"复制评分数据"提示
 * - 校验不通过：直接提示错误，不提交也不弹窗
 * - 校验通过 且 需要复制提示：弹出提示（暂不提交，由用户后续点击 是/否 触发实际提交）
 * - 校验通过 且 不需要复制提示：直接提交
 */
export const trySubmit = (currentTableInfo, projectInfo) => {
  return (dispatch) => {
    if (!validateScore(currentTableInfo)) {
      message.error("分数校验不通过");
      return;
    }

    // 判断是否需要弹出"复制评分数据"提示
    const projectId = String(projectInfo.get("id"));
    const tableId = String(currentTableInfo.get("id"));
    const group = getGroup(projectId, tableId);
    if (group) {
      const otherTables = getOtherTables(projectInfo, group, tableId);
      const allUnfilled = otherTables.every(
        (t) => !isTableFilled(t.id, projectInfo)
      );
      if (allUnfilled) {
        dispatch({
          type: constant.SHOW_COPY_PROMPT,
          targetNames: otherTables.map((t) => t.title),
          targetIds: otherTables.map((t) => t.id)
        });
        return;
      }
    }

    // 不需要弹窗，直接提交
    dispatch(submitScore(currentTableInfo, projectInfo));
  };
};

export const submitScore = (currentTableInfo, projectInfo, stay) => {
  return (dispatch) => {
    if (!validateScore(currentTableInfo)) {
      message.error("分数校验不通过");
      return;
    }

    let data = currentTableInfo.set("scorer", localStorage.getItem("userId"));
    Post(`${API.SCORE}?rounds=${projectInfo.get("status")}`, data).then(
      (res) => {
        message.success("提交成功！");
        // 确认提交后把本地缓存更新为"提交后的数据"（静默，不弹"自动保存成功"），
        // 避免下次打开该表时"是否加载自动保存内容"恢复提交前的旧数据。
        dispatch(autoSave(true));
        // 标记本会话已提交过该表（内存态，刷新/重进页面即失效）：
        // - 提交后点"返回任务列表"继续评分（同会话）→ LOAD_ALL_TABLES 直接恢复
        //   提交后的数据展示，且 CHECK_AUTO_SAVE 不再弹"是否加载自动保存内容"；
        // - 退出页面再次进入（store 重置）→ 标记消失，回到"不自动回填 + 弹窗询问"。
        dispatch({
          type: constant.CHANGE_ITEM,
          target: ["autoSaveHandled", String(currentTableInfo.get("id"))],
          value: true
        });
        // stay=true：提交后留在评分页（用于"切 tab 前提交并切换"场景）；
        // 默认提交后跳转"打分完成"页（OkPage）
        if (!stay) {
          dispatch({
            type: constant.CHANGE_ITEM,
            target: ["currentPage"],
            value: 3
          });
        }
        // 同步前端 tables 状态为"已评分"（后端已落库，但 projectInfo 是进入页面时
        // 拉的快照，不更新的话切 tab 时 scored 仍为 false，会误弹
        // "当前评分表尚未提交，请确认是否提交？"）。
        const submittedTid = String(currentTableInfo.get("id"));
        const syncedTables = projectInfo.get("tables").map((t) =>
          String(t.get("id")) === submittedTid ? t.set("status", 1) : t
        );
        dispatch({
          type: constant.CHANGE_ITEM,
          target: ["projectInfo", "tables"],
          value: syncedTables
        });
      }
    );
  };
};

// "自动保存成功"提示的防抖计时器：连续输入时只弹一次 message，
// 避免 antd message 堆积成"自动保存成功 自动保存成功 自动保存成功..."。
// silent 模式（提交后调用）不走防抖，立即同步执行。
let autoSaveMsgTimer = null;

export const autoSave = (silent) => {
  return (dispatch) => {
    if (silent) {
      // 提交后调用：立即同步更新缓存，确保切回时不弹"加载旧自动保存"
      dispatch({
        type: constant.AUTO_SAVE,
        silent: true
      });
      return;
    }
    // 普通输入触发：防抖 600ms，多个连续输入合并为一次提示
    if (autoSaveMsgTimer) clearTimeout(autoSaveMsgTimer);
    autoSaveMsgTimer = setTimeout(() => {
      dispatch({
        type: constant.AUTO_SAVE,
        silent: false
      });
      autoSaveMsgTimer = null;
    }, 600);
  };
};

export const loadAutoSave = (tableId) => ({
  type: constant.LOAD_AUTO_SAVE,
  tableId
});

/**
 * 检测某表是否有未处理的自动保存内容（进入页面 / 切换 tab 时调用）：
 * 仅"弹窗询问"，不恢复数据；该表已处理过则直接跳过不再弹。
 */
export const checkAutoSave = (tableId) => ({
  type: constant.CHECK_AUTO_SAVE,
  tableId
});

/**
 * 用户点弹窗"否"：标记该表已处理（不再询问），不恢复数据。
 */
export const dismissAutoSave = (tableId) => ({
  type: constant.DISMISS_AUTO_SAVE,
  tableId
});

/**
 * 复制确认：把源表填写的数据按因子路径映射存入 pending（localStorage），
 * 下次打开同组其它表时由 loadScoreTable 回填。用户可核对后再自行提交。
 */
export const confirmCopy = (currentTableInfo, projectInfo) => {
  return (dispatch) => {
    const projectId = String(projectInfo.get("id"));
    const tableId = String(currentTableInfo.get("id"));
    const group = getGroup(projectId, tableId);
    if (group) {
      const groupId = groupIdOf(group);
      const valueMap = buildValueMap(currentTableInfo);
      setPending(projectId, groupId, {
        sourceTableId: tableId,
        valueMap,
        appliedTables: []
      });
      markPrompted(projectId, groupId);
    }
    dispatch({
      type: constant.COPY_CONFIRM
    });
  };
};

/**
 * 复制取消：仅关闭提示（是否已提示已在提交时标记，不会再次弹出）
 */
export const cancelCopy = () => {
  return (dispatch) => {
    dispatch({
      type: constant.COPY_CANCEL
    });
  };
};
